<style>

</style>

<template>
    <div style="width: 100%">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span >当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!--搜索-->
        <div style="background-color: white;padding: 10px 30px 1px 30px">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="标题: ">
                    <el-input v-model="form.name" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="录入时间: ">
                    <div class="block">
                        <el-date-picker
                                v-model="form.lrDate"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="排序类型: ">
                    <div>
                        <el-radio-group v-model="form.pxlx" size="small">
                            <el-radio-button label="按录入时间" style="margin-right: 25px">
                                <el-row>
                                    <span>按录入时间</span>
                                    <i class="el-icon-bottom"></i>
                                </el-row>
                            </el-radio-button>
                            <el-radio-button label="按更新时间"></el-radio-button>
                        </el-radio-group>
                    </div>
                </el-form-item>
                <el-form-item style="text-align: right">
                    <el-button plain>重置</el-button>
                    <el-button type="primary" @click="onSubmit">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--按钮-->
        <div style="text-align: right;margin-top: 10px;margin-right: 27px">
            <el-button type="primary" @click="addDialogFormVisible = true">新增</el-button>
        </div>
        <div style="background-color: white;padding: 30px 20px 0 20px">
            <template>
                <el-table
                        :data="tableData"
                        style="width: 100%"
                        :header-cell-style="{background:'#eef1f6',color:'#595a5a'}"
                        border>
                    <el-table-column
                            prop="bt"
                            label="标题">
                        <template slot-scope="scope">
                            <el-button type="text" @click="on">{{scope.row.bt}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="content"
                            label="内容">
                    </el-table-column>
                    <el-table-column
                            prop="state"
                            label="状态">
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="创建时间">
                    </el-table-column>
                    <el-table-column
                            prop="updateTime"
                            label="更新时间">
                    </el-table-column>
                    <el-table-column
                            prop="czr"
                            label="操作人">
                    </el-table-column>
                    <el-table-column prop="handel" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="edit(scope.$index,scope.row)">编辑</el-button>
                            </br>
                            <el-button type="text" size="mini" @click="fb" style="margin-top: 2px">发布
                            </el-button>
                            </br>
                            <el-button type="text" size="mini" @click="zf" style="margin-top: 2px">作废</el-button>
                            </br>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <!--分页-->
            <div style="text-align: right;padding-right: 17px">
                <div class="block">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="page.currentPage1"
                            :page-size="100"
                            layout="total, prev, pager, next"
                            :total="1000">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--新增弹框-->
        <el-dialog :close-on-click-modal="false"   title="新增" :visible.sync="addDialogFormVisible">
            <el-form :model="addForm" :rules="rules">
                <el-form-item label="标题" :label-width="addForm.formLabelWidth" prop="bt">
                    <el-input v-model="addForm.bt"></el-input>
                </el-form-item>
                <el-form-item label="内容" :label-width="addForm.formLabelWidth" prop="content">
                    <el-input
                            type="textarea"
                            placeholder="请输入内容"
                            v-model="addForm.content"
                            maxlength="30"
                            show-word-limit
                            :rows="10"
                    >
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addDialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addDialogFormVisible = false">保 存</el-button>
            </div>
        </el-dialog>
        <!--编辑弹框-->
        <el-dialog :close-on-click-modal="false"   title="新增" :visible.sync="editDialogFormVisible">
            <el-form :model="editForm" :rules="rules">
                <el-form-item label="标题" :label-width="editForm.formLabelWidth" prop="bt">
                    <el-input v-model="editForm.bt"></el-input>
                </el-form-item>
                <el-form-item label="内容" :label-width="editForm.formLabelWidth" prop="content">
                    <el-input
                            type="textarea"
                            placeholder="请输入内容"
                            v-model="editForm.content"
                            maxlength="30"
                            show-word-limit
                            :rows="10"
                    >
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="editDialogFormVisible = false">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ElRow from "element-ui/packages/row/src/row";

    export default {
        components: {ElRow},
        data: function () {
            return {
                page:{
                    currentPage1:5
                },
                // 搜索表单
                form: {
                    bt: '',
                    lrDate: '',
                    pxlx: ''
                },
                //新增表单
                addForm: {
                    bt: '',
                    content: '',
                    formLabelWidth: '200px',
                    closeOn: false
                },
                editForm: {
                    bt: '',
                    content: '',
                    formLabelWidth: '200px',
                    closeOn: false
                },
                // 弹框
                addDialogFormVisible: false,
                editDialogFormVisible: false,
                rules: {
                    bt: [
                        {required: true, message: '请输入标题', trigger: 'blur'},

                    ],
                    content: [
                        {required: true, message: '请输入内容', trigger: 'blur'},

                    ],
                },
                // 表格
                tableData: [{
                    bt: '数据采集插件安装方法',
                    content: '王小虎',
                    state: '待发布',
                    createTime: '2020-06-06 12:32',
                    updateTime: '2020-06-06 12:32',
                    czr: '林萧'
                }, {
                    bt: '数据采集插件安装方法',
                    content: '王小虎',
                    state: '待发布',
                    createTime: '2020-06-06 12:32',
                    updateTime: '2020-06-06 12:32',
                    czr: '林萧'
                }, {
                    bt: '数据采集插件安装方法',
                    content: '王小虎',
                    state: '待发布',
                    createTime: '2020-06-06 12:32',
                    updateTime: '2020-06-06 12:32',
                    czr: '林萧'
                }, {
                    bt: '数据采集插件安装方法',
                    content: '王小虎',
                    state: '待发布',
                    createTime: '2020-06-06 12:32',
                    updateTime: '2020-06-06 12:32',
                    czr: '林萧'
                }]

            };
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            onSubmit() {
                console.log('submit!');
            },
            edit(index, row) {
                this.editForm.bt = row.bt;
                this.editForm.content = row.content;
                this.editDialogFormVisible = true;
            },
            // 发布
            fb() {
                this.$confirm('此操作将更改已发布状态, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '发布成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '发布失败'
                    });
                });
            },
            // 作废
            zf() {
                this.$confirm('此操作将更改作废状态, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '更改作废状态成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消更改作废状态'
                    });
                });
            },
            //跳转说明窗口
            on(){
                window.open('https://www.wulihub.com.cn/gc/WZkk63/查看详情.html','','height=1000, width=1000');
            }

        }
    }
</script>
